export { default as Img200 } from './processed/200/sunlight.jpg';
export { default as Img400 } from './processed/400/sunlight.jpg';
export { default as Img600 } from './processed/600/sunlight.jpg';
export { default as Imgthumb } from './processed/thumb/sunlight.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/sunlight.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/sunlight.jpg';
export const ImgData = { width: 1024, height: 768, ratio: 0.75, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      6,
      194,
      78
    ],
    "_population": 2379,
    "_hsl": [
      0.39716312056737585,
      0.94,
      0.39215686274509803
    ]
  },
  "LightVibrant": {
    "_rgb": [
      225,
      148,
      169
    ],
    "_population": 3,
    "_hsl": [
      0.9545454545454546,
      0.5620437956204378,
      0.7313725490196079
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      100,
      38,
      4
    ],
    "_population": 627,
    "_hsl": [
      0.05902777777777778,
      0.9230769230769231,
      0.20392156862745098
    ]
  },
  "Muted": {
    "_rgb": [
      146,
      93,
      69
    ],
    "_population": 1728,
    "_hsl": [
      0.051948051948051945,
      0.35813953488372097,
      0.42156862745098034
    ]
  },
  "LightMuted": {
    "_rgb": [
      173,
      194,
      209
    ],
    "_population": 159,
    "_hsl": [
      0.5694444444444445,
      0.2812499999999999,
      0.7490196078431373
    ]
  },
  "DarkMuted": {
    "_rgb": [
      64,
      61,
      97
    ],
    "_population": 770,
    "_hsl": [
      0.6805555555555555,
      0.22784810126582272,
      0.30980392156862746
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/sunlight.js